import angular from 'angular';
import 'angular-bootstrap';
import '../../common/components/locale';
import './galleriesServices';

const galleriesControllers = angular.module('applicationModule.galleriesControllers', ['applicationModule.galleriesServices', 'ui.bootstrap']);

galleriesControllers.controller('GalleriesController', ['$scope', '$rootScope', '$stateParams', 'NgTableParams', 'Galleries', 'growl', 'AppsoupAPI', 'Permissions', '$state', '$modal', function ($scope, $rootScope, $stateParams, NgTableParams, Galleries, growl, AppsoupAPI, Permissions, $state, $modal) {
    'use strict';

    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('galleries');
    $scope.application_id = $stateParams.application_id;

    $scope.tableParams = new NgTableParams(AppsoupAPI.getDefaultTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;
            return Galleries.getList($scope.application_id, params._params)
                .then(function (response) {
                    params.total(response.galleries.total);
                    params.count(response.galleries.per_page);
                    params.page(response.galleries.current_page);
                    return response.galleries.data;
                }).finally(function () {
                    $scope.isLoading = false;
                });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

    $scope.copyGallery = function (id) {
        Galleries.copy(id).then(function (response) {
            const data = response.data;
            if (data.success) {
                growl.success('MODULES.GALLERIES.SUCCESS.COPY_GALLERY');
                $state.go($state.current, {searchGalleries: $stateParams.searchGalleries}, {reload: true});
            } else if (data.error === 'ERROR.GALLERY_NOT_EXISTS') {
                growl.error('ERROR.GALLERY_NOT_EXISTS');
            } else {
                growl.error('MODULES.GALLERIES.ERROR.COPY_GALLERY');
            }
        });
    };

    $scope.newGallery = function () {
        const modalInstance = $modal.open({
            templateUrl: 'views/application/galleries/gallery.tpl.html',
            controller: 'GalleryModalController',
            resolve: {
                gallery: function () {
                    return {
                        app_id: $scope.application_id
                    };
                }
            }
        });
        modalInstance.result.then(function (gallery) {
            $scope.tableParams.data.push(gallery);
            growl.success('MODULES.GALLERIES.SUCCESS.CREATED');
        }).catch(() => {});
    };

    $scope.editGallery = function (data, index) {
        const modalInstance = $modal.open({
            templateUrl: 'views/application/galleries/gallery.tpl.html',
            controller: 'GalleryModalController',
            resolve: {
                gallery: function () {
                    return data;
                }
            }
        });
        modalInstance.result.then(function (gallery) {
            $scope.tableParams.data[index] = gallery;
            growl.success('MODULES.GALLERIES.SUCCESS.EDITED');
        }).catch(() => {});
    };

    $scope.remove = function ($event) {
        $event.stopImmediatePropagation();
    };

    $scope.removeGallery = function (id, index) {
        Galleries.remove(id, $scope.application_id)
            .then(function (response) {
                const data = response.data;
                if (data.success) {
                    growl.success('MODULES.GALLERIES.SUCCESS.DELETED');
                    $scope.tableParams.data.splice(index, 1);
                } else {
                    growl.error('MODULES.GALLERIES.ERROR.DELETED');
                }
            });
    };

    $scope.searchGalleries = function (search) {
        $scope.isFind = true;
        const find = angular.copy(search);
        angular.extend($scope.tableParams._params, find);
        $scope.searchItem = $scope.search;
        $scope.isFind = false;
    };

    $scope.clearSearch = function () {
        $scope.search = {};
        if (angular.isDefined($scope.tableParams._params.name)) {
            $scope.tableParams._params.name = undefined;
        }
        $stateParams.searchGalleries = null;
        $scope.searchItem = null;
    };

    $scope.$watch('search', function () {
        $scope.check = false;
        angular.forEach($scope.search, function (val) {
            if (angular.isDefined(val) && angular.isDefinedNotEmpty(val)) {
                $scope.check = true;
            }
        });
    }, true);

}]);

// Gallery Modal Controller
galleriesControllers.controller('GalleryModalController', ['$scope', '$state', '$stateParams', '$modalInstance', 'growl', 'Galleries', 'gallery', function ($scope, $state, $stateParams, $modalInstance, growl, Galleries, gallery) {
    'use strict';

    const appId = $stateParams.application_id;
    $scope.gallery = {};
    $scope.gallery.app_id = appId;
    $scope.editMode = false;

    if (gallery.name) {
        $scope.editMode = true;
        $scope.gallery = angular.copy(gallery);
    }

    $scope.ok = function () {
        $scope.$broadcast('show-errors-check-validity');
        $scope.isLoading = true;

        Galleries.save($scope.gallery, $scope.editMode)
            .then(function (response) {
                const data = response.data;
                if (data.success) {
                    $modalInstance.close(data.gallery);
                } else {
                    if (typeof data.error === 'object') {
                        $scope.formErrors = data.error;
                    } else {
                        growl.error('MODULES.GALLERIES.ERROR.CREATED');
                    }
                }
            })
            .finally(function () {
                $scope.isLoading = false;
            });
    };

    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };

    $scope.remove = function () {
        $modalInstance.dismiss('cancel');
    };

    $scope.inputErrors = {
        'name': [{type: '$invalid', msg: 'ERROR.REQUIRE.NAME'}]
    };
}]);

// Gallery Elements List Controller
galleriesControllers.controller('GalleryElementsController', ['$scope', '$rootScope', '$stateParams', 'NgTableParams', 'GalleryElements', 'growl', 'AppsoupAPI', 'Permissions', '$state', '$modal', function ($scope, $rootScope, $stateParams, NgTableParams, GalleryElements, growl, AppsoupAPI, Permissions, $state, $modal) {
    'use strict';

    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('galleries');
    $scope.application_id = $stateParams.application_id;
    $scope.gallery_id = $stateParams.galleryId;

    $scope.tableParams = new NgTableParams(AppsoupAPI.getTitleTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;
            return GalleryElements.getList($scope.application_id, $scope.gallery_id, params._params)
                .then(function (response) {
                    params.total(response.elements.total);
                    params.count(response.elements.per_page);
                    params.page(response.elements.current_page);
                    return response.elements.data;
                }).finally(function () {
                    $scope.isLoading = false;
                });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

    $scope.newElement = function () {
        const modalInstance = $modal.open({
            templateUrl: 'views/application/galleries/element.tpl.html',
            controller: 'GalleryElementModalController',
            resolve: {
                element: function () {
                    return {
                        app_id: $scope.application_id,
                        gallery_id: $scope.gallery_id
                    };
                }
            }
        });
        modalInstance.result.then(function (element) {
            $scope.tableParams.data.push(element);
            growl.success('MODULES.GALLERIES.ELEMENTS.SUCCESS.CREATED');
        }).catch(() => {});
    };

    $scope.editElement = function (data, index) {
        const modalInstance = $modal.open({
            templateUrl: 'views/application/galleries/element.tpl.html',
            controller: 'GalleryElementModalController',
            resolve: {
                element: function () {
                    return data;
                }
            }
        });
        modalInstance.result.then(function (element) {
            $scope.tableParams.data[index] = element;
            growl.success('MODULES.GALLERIES.ELEMENTS.SUCCESS.EDITED');
        }).catch(() => {});
    };

    $scope.remove = function ($event) {
        $event.stopImmediatePropagation();
    };

    $scope.removeElement = function (id, index) {
        GalleryElements.remove(id, $scope.application_id)
            .then(function (response) {
                const data = response.data;
                if (data.success) {
                    growl.success('MODULES.GALLERIES.ELEMENTS.SUCCESS.DELETED');
                    $scope.tableParams.data.splice(index, 1);
                } else {
                    growl.error('MODULES.GALLERIES.ELEMENTS.ERROR.DELETED');
                }
            });
    };

    $scope.changeOrder = function ($event, key1, key2) {
        let data = $scope.tableParams.data;
        $event.stopImmediatePropagation();
        GalleryElements.changeOrder({
            order_ids: [$scope.tableParams.data[key1].order, $scope.tableParams.data[key2].order],
            application_id: $scope.application_id
        })
            .then(function (response) {
                if (response.data.success) {
                    data = angular.changeOrderResponse(data, key1, key2);
                }
            });
        $scope.tableParams.data = data;
    };

}]);

// Gallery Element Modal Controller
galleriesControllers.controller('GalleryElementModalController', ['$scope', '$state', '$stateParams', '$modalInstance', 'growl', 'GalleryElements', 'element', function ($scope, $state, $stateParams, $modalInstance, growl, GalleryElements, element) {
    'use strict';

    const appId = $stateParams.application_id;
    $scope.element = {};
    $scope.element.app_id = appId;
    $scope.element.gallery_id = element.gallery_id;
    $scope.editMode = false;

    if (element.title) {
        $scope.editMode = true;
        $scope.element = angular.copy(element);
    }

    $scope.ok = function () {
        $scope.$broadcast('show-errors-check-validity');

        if ($scope.elementForm.$valid) {
            $scope.isLoading = true;

            GalleryElements.save($scope.element, $scope.editMode)
                .then(function (response) {
                    const data = response.data;
                    if (data.success) {
                        $modalInstance.close(data.element);
                    } else {
                        if (typeof data.error === 'object') {
                            $scope.formErrors = data.error;
                        } else {
                            growl.error('MODULES.GALLERIES.ELEMENTS.ERROR.CREATED');
                        }
                    }
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        }
    };

    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
    };

    $scope.remove = function () {
        $modalInstance.dismiss('cancel');
    };

    $scope.inputErrors = {
        'title': [{type: '$invalid', msg: 'ERROR.REQUIRE.TITLE'}]
    };
}]);

export default galleriesControllers;
